import { http, providerApi } from '@/core/api/';
import codeDocumentTypes from '@/utils/constants/documentTypes';

const apiUrl = 'api/pei';

export default {
  downloadDocument(documentFile) {
    const byteChars = atob(documentFile.content);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);

    let blob = new Blob([byteArray], {
      type: documentFile.contentType,
    });
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentFile.filename;
    link.click();
  },
  downloadStudentDocument(evaluationId, documentId) {
    return new Promise((resolve, reject) => {
      http
        .get(
          `api/studentevaluation/${evaluationId}/downloadDocuments/${documentId}`
        )
        .then((response) => {
          if (response && response.data) {
            this.downloadDocument(response.data);
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  documentsPeiDownloadFiles(id) {
    http.get(`api/pei/downloaddocument?id=${id}`).then((response) => {
      this.downloadDocument(response.data);
    });
  },
  documentDownloadLocalFile(file) {
    let fr = new FileReader();
    fr.readAsDataURL(file);
    let blob = new Blob([file], { type: 'application/pdf' });

    let objectURL = window.URL.createObjectURL(blob);

    let link = document.createElement('a');
    link.href = objectURL;
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
  documentDownloadReport(content, filename, contentType) {
    let binaryString = window.atob(content);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      let ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }

    let blob = new Blob([bytes], { type: contentType || 'application/pdf' });

    let objectURL = window.URL.createObjectURL(blob);

    let link = document.createElement('a');
    link.href = objectURL;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
  documentsDeleteFiles(peiAtServiceId) {
    return http.get(
      `api/atservice/deleteatdocument?peiAtServiceId=${peiAtServiceId}`
    );
  },
  documentsLoadFiles(peiAtServiceId) {
    return http.get(
      `api/atservice/loadatdocument?peiAtServiceId=${peiAtServiceId}`
    );
  },
  convertToBlob(documentFile) {
    const blob = this.getBlobConversion(documentFile);
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = documentFile.fileName;
    link.click();
  },
  getBlobConversion(documentFile) {
    const byteArray = this.convertToByteArray(documentFile.content);
    return new Blob([byteArray], {
      type: documentFile.contentType,
    });
  },
  convertToByteArray(documentContent) {
    const byteChars = atob(documentContent);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
      byteNumbers[i] = byteChars.charCodeAt(i);
    }
    return new Uint8Array(byteNumbers);
  },
  async evaluationDownloadFiles(
    studentEvaluationId,
    studentEvaluationsDocumentIds
  ) {
    return http
      .get(
        `/api/studentevaluation/${studentEvaluationId}/documents/${studentEvaluationsDocumentIds}`,
        { responseType: 'blob' }
      )
      .then((response) => {
        let blob = new Blob([response.data], { type: 'application/pdf' });
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'Documento Adjunto.pdf';
        link.click();
      })
      .catch((e) => {
        return e;
      });
  },
  async downloadDocumentByAttachmentId(
    studentEvaluationsDocumentIds,
    studentEvaluationsAttachmentIds
  ) {
    let documentId = null;
    if (studentEvaluationsDocumentIds != '') {
      documentId = studentEvaluationsDocumentIds;
    }
    let attachmentId = null;
    if (studentEvaluationsAttachmentIds != '') {
      attachmentId = studentEvaluationsAttachmentIds;
    }
    return http
      .get(`/api/documents/getdocument/${documentId}/${attachmentId}/2`)
      .then((response) => {
        this.downloadDocument(response.data);
      })
      .catch((e) => {
        return e;
      });
  },
  // Download document according to attachment id and category.
  async downloadDocumentByAttachmentIdByDocumentCategory(
    attachmentId,
    documentCategory
  ) {
    return http
      .get(
        `/api/documents/documentbycategory/${attachmentId}/${documentCategory}`
      )
      .then((response) => {
        this.downloadDocument(response.data);
      })
      .catch((e) => {
        return e;
      });
  },
  async downloadDocumentForThrerapyReferral(attachmentId) {
    return http
      .get(`/api/documents/downloadtherapyreferral/${attachmentId}`)
      .then((response) => {
        this.downloadDocument(response.data);
      })
      .catch((e) => {
        return e;
      });
  },
  async getDocument(id) {
    return http
      .get(`/api/documents/${id}`)
      .then((response) => {
        this.downloadDocument(response.data);
      })
      .catch((e) => {
        throw e;
      });
  },
};
